var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresentersSection = function SvgPresentersSection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 199 89"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6C8A8E",
    transform: "translate(-10.5 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M75.903 46.601A14.45 14.45 0 0 0 80 36.5C80 28.492 73.508 22 65.5 22S51 28.492 51 36.5c0 4.38 1.943 8.308 5.014 10.967.224-4.27 3.126-7.829 7.057-9.031a5.5 5.5 0 1 1 5.191-.179 10.01 10.01 0 0 1 7.64 8.344",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 5,
    x: 39,
    y: 54.467,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 2,
    x: 26,
    y: 64.467,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 2,
    x: 26,
    y: 71.467,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 2,
    x: 26,
    y: 78.467,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M164.903 46.601A14.45 14.45 0 0 0 169 36.5c0-8.008-6.492-14.5-14.5-14.5S140 28.492 140 36.5c0 4.38 1.943 8.308 5.014 10.967.224-4.27 3.126-7.829 7.057-9.031a5.5 5.5 0 1 1 5.191-.179 10.01 10.01 0 0 1 7.641 8.344",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 5,
    x: 128,
    y: 54.467,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 2,
    x: 115,
    y: 64.467,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 2,
    x: 115,
    y: 71.467,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 2,
    x: 115,
    y: 78.467,
    rx: 1
  }))));
};
export { SvgPresentersSection as ReactComponent };
export default "data:image/svg+xml;base64,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";